import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@coolremote/shared';

const SimpleSelect = ({ options, value, onChange, placeholder, ...props }) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      simulateNativeOnChange
      options={options}
      placeholder={placeholder}
      menuPortal
      height={34}
      maxMenuHeight={200}
      {...props}
    />
  );
};

SimpleSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

SimpleSelect.defaultProps = {
  placeholder: 'Select an option',
};

export default SimpleSelect;
